module.exports = __webpack_public_path__ + "img/contemporary-house-3.186f2190.jpg";